import { Page } from '../Page'
import { IntroductionSlide } from './IntroductionSlide'

export function Home() {
    return (
        <Page>
            <IntroductionSlide />
        </Page>
    )
}
